import styled, { css } from "styled-components";

import { globalStyle } from "global/globalStyle";

interface IBaseCardContainer {
  selected?: boolean;
  height?: number;
  disabled?: boolean;
  background?: string;
  isLog?: boolean;
  fixedBorder?: boolean;
}

export const Container = styled.div<IBaseCardContainer>`
  width: calc(100% - 40px);
  height: ${(props) =>
    props.height ? `calc(${props.height}px - 40px)` : "auto"};
  padding: ${(props) => (props.isLog ? "0 20px" : "20px")};
  margin-bottom: ${(props) => (props.isLog ? "10px" : "0")};
  background: ${(props) =>
    props.background ?? globalStyle.card.color.default_color};
  border-radius: 8px;
  border: 2px solid ${globalStyle.card.border.default_color};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};

  &:hover {
    border: ${(props) =>
      props.disabled && !props.fixedBorder
        ? "2px solid " + globalStyle.card.border.default_color
        : "2px solid " + globalStyle.card.border.hover};
  }

  ${(props) =>
    props.fixedBorder &&
    css`
      border: 2px solid ${globalStyle.card.border.hover};
    `}

  ${(props) =>
    props.selected &&
    css`
      background: ${globalStyle.card.color.selected};
      border: 2px solid ${globalStyle.card.border.selected};
    `}
`;
